import AppButton from '@/components/Button/Button.vue';
import AppIconButton from '@/components/Button/IconButton.vue';
import AppTextButton from '@/components/Button/TextButton.vue';

export default {
    AppButton,
    AppIconButton,
    AppTextButton,
}
